import { Pipe, PipeTransform } from '@angular/core';
import { rangeTrackerColor } from '../../data/shared/range-tracker-color';
import { Tables, TablesInsert } from '../../data/database.types';
import { Topic } from '../../data/topic/topic';

@Pipe({name: 'rangeTrackerColor'})
export class RangeTrackerColorPipe implements PipeTransform {
  transform(vm: {entry?: TablesInsert<'entries'>, topic: Topic}): string {
    const rangeTarget = vm.topic?.range_target;
    return rangeTrackerColor(rangeTarget, vm.entry?.value)
  }

}
